export const env = {
  url: import.meta.env.VITE_API_URL,
  webSocketUrl: import.meta.env.VITE_WS_URL,
  sampleUrl: import.meta.env.VITE_SAMPLE_URL,
  isLocal: import.meta.env.VITE_IS_LOCAL || null,
};
